import { lazy, ComponentType } from 'react';
import { ROUTES } from '@shared/config/routes';

// Lazy load all page components
const Landing = lazy(() => import('@features/Landing/components/Landing'));
const Callback = lazy(() => import('@features/Auth/pages/Callback'));
const VerifyEmail = lazy(() => import('@features/VerifyEmail/components/VerifyEmail'));
const ForgotPassword = lazy(() => import('@features/ForgotPassword/components/ForgotPassword'));
const ResetPassword = lazy(() => import('@features/ResetPassword/components/ResetPassword'));
const OAuthCallback = lazy(() => import('@features/OAuthCallback/components/OAuthCallback'));
const Home = lazy(() => import('@features/Home/components/Home'));
const Onboarding = lazy(() => import('@features/Onboarding/components/Onboarding'));

// Education
const AITyping = lazy(() => import('@features/AITyping/components/AITyping'));

// Sandbox
const SandboxModeSelector = lazy(() => import('@features/Sandbox/components/SandboxModeSelector'));
const SandboxEditor = lazy(() => import('@features/Sandbox/components/SandboxEditor'));

// Repository
const Repository = lazy(() => import('@features/Repository/components/Repository'));

// Education - Problems
const Problems = lazy(() => import('@features/Problems/components/Problems'));
const ProblemView = lazy(() => import('@features/ProblemView/components/ProblemView'));

// User
const Profile = lazy(() => import('@features/Profile/components/Profile'));
const Settings = lazy(() => import('@features/Settings/components/Settings'));

// Nova
const NovaDirectory = lazy(() => import('@features/nova/components/NovaDirectory').then(module => ({ default: module.NovaDirectory })));
const NovaNoteView = lazy(() => import('@features/nova/components/NovaNoteView').then(module => ({ default: module.NovaNoteView })));

// Roadmap
const CalendarPage = lazy(() => import('@features/Roadmap/CalendarPage'));
const MyRoadmapsPage = lazy(() => import('@features/Roadmap/MyRoadmapsPage'));

export interface RouteConfig {
  path: string;
  component: ComponentType;
}

export const publicRoutes: RouteConfig[] = [
  {
    path: ROUTES.LANDING,
    component: Landing,
  },
  {
    path: ROUTES.LOGIN,
    component: Landing,
  },
  {
    path: '/callback',
    component: Callback,
  },
  {
    path: ROUTES.VERIFY_EMAIL,
    component: VerifyEmail,
  },
  {
    path: ROUTES.AUTH_VERIFY,
    component: VerifyEmail,
  },
  {
    path: ROUTES.FORGOT_PASSWORD,
    component: ForgotPassword,
  },
  {
    path: ROUTES.RESET_PASSWORD,
    component: ResetPassword,
  },
  {
    path: ROUTES.OAUTH_CALLBACK,
    component: OAuthCallback,
  },
];

export const protectedRoutes: RouteConfig[] = [
  {
    path: ROUTES.ONBOARDING,
    component: Onboarding,
  },
  {
    path: ROUTES.HOME,
    component: Home,
  },

  // Education
  {
    path: ROUTES.AI_TYPING,
    component: AITyping,
  },
  {
    path: ROUTES.PROBLEMS,
    component: Problems,
  },
  {
    path: ROUTES.PROBLEM,
    component: ProblemView,
  },

  // Sandbox
  {
    path: ROUTES.SANDBOX,
    component: SandboxModeSelector,
  },
  {
    path: ROUTES.SANDBOX_PROJECT,
    component: SandboxEditor,
  },

  // Repository
  {
    path: ROUTES.REPOSITORY,
    component: Repository,
  },

  // User
  {
    path: ROUTES.PROFILE,
    component: Profile,
  },
  {
    path: ROUTES.SETTINGS,
    component: Settings,
  },

  // Nova
  {
    path: ROUTES.NOVA,
    component: NovaDirectory,
  },
  {
    path: ROUTES.NOVA_NOTE,
    component: NovaNoteView,
  },

  // Roadmap
  {
    path: ROUTES.CALENDAR,
    component: CalendarPage,
  },
  {
    path: ROUTES.MY_ROADMAPS,
    component: MyRoadmapsPage,
  },
];
